import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import MeterReportData from '../../Components/MeterReportData';
import Page from '../../Components/Page';

import { selectChargingPoints } from '../../redux/selectors/chargingPoints';

import './style.scss';

function MeterReport() {
  const chargingPoints = useSelector(selectChargingPoints);

  const { t } = useTranslation();

  const urlParams = new URLSearchParams(window.location.search);
  const cpId = urlParams.get('cp');
  const currentCp = chargingPoints?.length && chargingPoints.find((cp) => cp.id === cpId);

  return (
    <Page
      hasBack={true}
      title={currentCp ? `${t('meter_report_for')} ${currentCp?.cp_id}` : t('meter_reports')}>
      <MeterReportData />
    </Page>
  );
}

export default MeterReport;
